<template>
  <span @click="$emit('click')">
    <v-chip v-if="isSelected === true" color="red red--text lighten-5">
      <span>
        {{ text }}
      </span>
    </v-chip>
    <v-chip v-else>
      <span>
        {{ text }}
      </span>
      <v-icon left size="20" class="ma-0">add</v-icon>
    </v-chip>
  </span>
</template>

<script>
export default {
  props: {
    text: String,
    isSelected: Boolean,
  },
}
</script>
